<template>
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="12" md="12">
                    <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                        <v-container>
                            <v-row class="mt-5">
                                <v-col cols="11" md="3" class="mt-n5 d-flex">
                                    <v-text-field v-if="existe!='si'" class='casilla_beige text-body-2' v-model="usuario" label="Usuario" dense rounded></v-text-field>
                                    <v-text-field v-else class='casilla_grey text-body-2' v-model="usuario" label="Usuario" dense rounded disabled></v-text-field>
                                    <v-btn @click="searchUser()" class="mt-1 ml-2" small color="teal" dark rounded><v-icon small>search</v-icon></v-btn>
                                </v-col>
                                <v-col cols="12" md="7" class="mt-n5">
                                    <v-alert class='text-caption' v-if="existe=='si'" shaped dense text type="success">
                                        Existe !!!
                                    </v-alert>
                                    <v-alert class='text-caption' v-else-if="existe=='no'" shaped dense text type="warning">
                                        Nuevo !!!
                                    </v-alert>
                                    <v-alert class='text-caption' v-else dense shaped text type="info">
                                        Selecciona Usuario !!!
                                    </v-alert>
                                </v-col>
                                <v-col cols="12" md="2" class="mt-n5 text-end">
                                        <strong class="mt-1">Editar Usuario</strong>
                                        <v-btn @click="d_users=true" class="mt-n1 ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>                                
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-sheet>
                    <v-container>
                        <v-row class="mt-2">
                            <v-col cols="12" md="8">
                                <v-row>
                                    <v-col cols="12" md="8">
                                        <v-row>
                                            <v-col cols="12" md="6" class="mt-n2">
                                                <v-text-field class='casilla_beige text-body-2' v-model="rut" label="Rut" dense rounded></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="10" class="mt-n2">
                                                <v-text-field class='casilla_beige text-body-2' v-model="nombre" label="Nombre" dense rounded></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="10" class="mt-n2">
                                                <v-text-field class='casilla_beige text-body-2' v-model="telefono" label="Telefono" dense rounded></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="10" class="mt-n2">
                                                <v-text-field class='casilla_beige text-body-2' v-model="email" label="Email" dense rounded></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>   
                                            <v-col cols="12" md="6" class="mt-n2">
                                                <v-select @change="cambiaTipo(tipo)" class='casilla_beige text-body-2' v-model="tipo" :items="tipos" label="Tipo" dense rounded></v-select>
                                            </v-col>
                                            <v-col cols="6" md="4" class="mt-n2">
                                                <v-text-field @keypress="onlyDecimal" class='casilla_beige text-body-2' v-model="comision" label="Comision (%)" dense rounded></v-text-field>
                                            </v-col>
                                            <v-col cols="6" md="5" class="mt-n2">
                                                <v-select class='casilla_beige text-body-2' v-model="estado" :items="estados" label="Estado" dense rounded></v-select>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-row>
                                            <v-col cols="12" md="12" class="text-center">
                                                <form method="post" action="#" enctype="multipart/form-data">
                                                    <div>
                                                        <img src="https://www.centrystore.cl/user-blue.png" alt="avatar" id="img" />
                                                        <input type="file" name="archivo" id="archivo" accept="image/*" /><br/>
                                                        <label for="archivo" style="border-radius: 25px; font-size:10pt">Cambiar Foto</label>
                                                    </div>
                                                </form>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="4">
                                <div class="mt-n2">
                                    <h5>PERMISOS</h5>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-row>
                                                <v-col cols="9" md="6">
                                                    <h5 class="mt-5 primary--text">DashBord</h5>
                                                    <v-divider></v-divider>
                                                </v-col>
                                                <v-col cols="3" md="6">
                                                    <v-switch v-model="permiso_1" dense></v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-n15">
                                        <v-col cols="12">
                                            <v-row>
                                                <v-col cols="9" md="6">
                                                    <h5 class="mt-5 primary--text">Orden de Trabajo</h5>
                                                    <v-divider></v-divider>
                                                </v-col>
                                                <v-col cols="3" md="6">
                                                    <v-switch v-model="permiso_2" dense></v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-n15">
                                        <v-col cols="12">
                                            <v-row>
                                                <v-col cols="9" md="6">
                                                    <h5 class="mt-5 primary--text">Productos</h5>
                                                    <v-divider></v-divider>
                                                </v-col>
                                                <v-col cols="3" md="6">
                                                    <v-switch v-model="permiso_3" dense></v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-n15">
                                        <v-col cols="12">
                                            <v-row>
                                                <v-col cols="9" md="6">
                                                    <h5 class="mt-5 primary--text">Devolución</h5>
                                                    <v-divider></v-divider>
                                                </v-col>
                                                <v-col cols="3" md="6">
                                                    <v-switch v-model="permiso_4" dense></v-switch>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-row class="mt-n15">
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col cols="9" md="6">
                                                <h5 class="mt-5 primary--text">Inventario</h5>
                                                <v-divider></v-divider>
                                            </v-col>
                                            <v-col cols="3" md="6">
                                                <v-switch v-model="permiso_5" dense></v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n15">
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col cols="9" md="6">
                                                <h5 class="mt-5 primary--text">Ajustes</h5>
                                                <v-divider></v-divider>
                                            </v-col>
                                            <v-col cols="3" md="6">
                                                <v-switch v-model="permiso_6" dense></v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n15">
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col cols="9" md="6">
                                                <h5 class="mt-5 primary--text">Usuarios</h5>
                                                <v-divider></v-divider>
                                            </v-col>
                                            <v-col cols="3" md="6">
                                                <v-switch v-model="permiso_7" dense></v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n15">
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col cols="9" md="6">
                                                <h5 class="mt-5 primary--text">Orden de Compra</h5>
                                                <v-divider></v-divider>
                                            </v-col>
                                            <v-col cols="3" md="6">
                                                <v-switch v-model="permiso_8" dense></v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-n15">
                                    <v-col cols="12">
                                        <v-row>
                                            <v-col cols="9" md="6">
                                                <h5 class="mt-5 primary--text">Reportes</h5>
                                                <v-divider></v-divider>
                                            </v-col>
                                            <v-col cols="3" md="6">
                                                <v-switch v-model="permiso_10" dense></v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>



            <v-container>
                <v-divider class="mt-4"></v-divider>
                <v-row class="mt-3">
                    <v-col cols="12" md="4">
                        <v-chip small dark @click="resetPass()">Resetear Contraseña</v-chip>
                    </v-col>
                    <v-col cols="12" md="2">
                        <v-btn @click="clsInput()" color="teal" rounded dark small block>Limpiar</v-btn>
                    </v-col>
                    <v-col cols="12" md="2">
                        <div v-if="btn_grabar!=true">
                            <v-btn v-if="existe!='si'" @click="dataUser()" color="teal" rounded dark small block>Grabar</v-btn>
                            <v-btn v-else @click="dataUser()" color="teal" rounded dark small block>Actualizar</v-btn>
                        </div>
                        <div v-else>
                            <v-btn v-if="existe!='si'" color="grey" rounded dark small block>Grabar</v-btn>
                            <v-btn v-else color="grey" rounded dark small block>Actualizar</v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" md="2"></v-col>
                </v-row>
            </v-container>
        </v-container>

        <!-- lista de usuarios -->
        <v-dialog v-model="d_users" transition="dialog-bottom-transition" max-width="80%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="4" md="8">
                        <v-btn @click="d_users=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        <strong class="ml-5">Usuarios</strong>
                    </v-col>
                    <v-col cols="8" md="4" class="text-end">
                        <v-text-field class='ml-5 mr-2 text-body-2' v-model="user_search" label="Buscar Usuario" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleUser" dense dark height="400px" fixed-header
                    :search="user_search" :headers="user_titulo" :items="user_lista" 
                    :page.sync="user_page" :items-per-page="user_itemsPerPage"  
                    @page-count="user_pageCount = $event" hide-default-footer class="elevation-1 text-size">
                    <template v-slot:item.usuario="{ item }">
                        <v-chip small>
                            {{ item.usuario }}
                        </v-chip>
                    </template>
                </v-data-table>
                <v-pagination v-model="user_page" :length="user_pageCount"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>


        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
form img{
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 6px solid #AAA;
}
form div:first-child{
  align-items: center;
}
form div:first-child input{
  display: none;
}
form div:first-child label{
  background: #1F5F74;
  color: white;
  padding: 6px 20px;
  cursor: pointer;
  border-radius: 3px;
}
form input{
  padding: 8px 20px;
  border: 1px solid #AAA;
  border-radius: 3px;
}
.casilla_beige {
    background-color: beige; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_grey {
    background-color: lightgray ; 
    height: 30px;
    border: 1px solid lightgray;
}
</style>
<script>
import axios from "axios";
export default {
  name: 'Usuarios',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    snack:false,
    color_snack:'',
    mensaje:'',
    existe:'',
    filled:true,
    disabled:true,

    rut:'',
    usuario:'',
    nombre:'',
    telefono:'',
    email:'',
    comision:0,
    foto:'',
    permiso_1:false,
    permiso_2:false,
    permiso_3:false,
    permiso_4:false,
    permiso_5:false,
    permiso_6:false,
    permiso_7:false,
    permiso_8:false,
    permiso_9:false,
    permiso_10:false,
    permiso_11:false,
    permiso_12:false,

    estado:'',
    estados:['V','N'],
    tipo:'',
    tipos:['Administrador','Tecnico','Bodeguero','Vendedor'],
    bloqueo:null,
    loading:false,

    d_users:false,
    user_titulo: [
      { text: 'Usuario', align: 'start', sortable: true, value: 'usuario' },
      { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
      { text: 'Nombre', align: 'start', sortable: true, value: 'nombre' },
      { text: 'Email', align: 'start', sortable: true, value: 'email' },
    ],
    user_lista: [],
    user_page: 1,
    user_pageCount: 0,
    user_itemsPerPage: 1000000,
    user_search:'', 
    btn_grabar:false,

  }),
  async mounted(){
    this.loading=true;
    this.user=localStorage.getItem('dops_myuser');
    this.apikey=localStorage.getItem('dops_apiKey');
    this.contrato=localStorage.getItem('dops_mycontrato');
    //listener de la foto
    const defaultFile = 'https://www.centrystore.cl/user-blue.png';
    const file = document.getElementById( 'archivo' );
    const img = document.getElementById( 'img' );
    file.addEventListener( 'change', e => {
        if( e.target.files[0] ){
            const reader = new FileReader( );
            reader.onload = function( e ){
                img.src = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);                       
        }else{
            img.src = defaultFile;
        }        
    });
    this.bloqueo = await this.myPermiso(7);
    if(parseInt(this.bloqueo)!=0){
        await this.serachUsersList();
    }
    this.loading=false
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            console.log('permisos', datos)
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async serachUsersList(){
        this.user_lista=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                usuario : 'all'
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.user_lista=datos;
            }
        } catch (error) {
            console.log(error)
        }
    },
    async handleUser(item){
        this.usuario = item.usuario;
        await this.searchUser()
        this.d_users=false
    },
    clsInput(){
        this.existe='';
        this.filled=true;
        this.disabled=true;
        this.rut='';
        this.usuario='';
        this.nombre='';
        this.telefono='';
        this.email='';
        this.comision=0;
        this.foto='';
        this.permiso_1=false;
        this.permiso_2=false;
        this.permiso_3=false;
        this.permiso_4=false;
        this.permiso_5=false;
        this.permiso_6=false;
        this.permiso_7=false;
        this.permiso_8=false;
        this.permiso_9=false;
        this.permiso_10=false;
        this.permiso_11=false;
        this.permiso_12=false;
        this.estado='';
        this.tipo='';
        const img = document.getElementById( 'img' );
        img.src = 'https://www.centrystore.cl/user-blue.png';
        this.btn_grabar=false;
    },
    async searchUser(){
        this.loading=true;
        if(this.usuario!='all'){
            try {
                const headers = {
                    'Content-Type' : 'application/json',
                    'Authorization' : 'Token ' + this.apikey
                };
                const params = {
                    contrato : this.contrato,
                    user :  this.user,
                    usuario :  this.usuario
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/user/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    const element = datos[0];
                    this.rut = element.rut;
                    this.tipo = element.tipo;
                    this.nombre = element.nombre;
                    this.telefono = element.telefono;
                    this.email = element.email;
                    this.comision = element.comision;
                    this.foto = element.foto;
                    if(this.foto!=''){
                        //insertar foto
                        const img = document.getElementById( 'img' );
                        img.src = this.foto;
                    };
                    this.permiso_1 = this.boleanPermiso(element.permiso_01);
                    this.permiso_2 = this.boleanPermiso(element.permiso_02);
                    this.permiso_3 = this.boleanPermiso(element.permiso_03);
                    this.permiso_4 = this.boleanPermiso(element.permiso_04);
                    this.permiso_5 = this.boleanPermiso(element.permiso_05);
                    this.permiso_6 = this.boleanPermiso(element.permiso_06);
                    this.permiso_7 = this.boleanPermiso(element.permiso_07);
                    this.permiso_8 = this.boleanPermiso(element.permiso_08);
                    this.permiso_9 = this.boleanPermiso(element.permiso_09);
                    this.permiso_10 = this.boleanPermiso(element.permiso_10);
                    this.permiso_11 = this.boleanPermiso(element.permiso_11);
                    this.permiso_12 = this.boleanPermiso(element.permiso_12);
                    this.estado = element.estado;
                    this.existe='si';
                    this.filled=false;
                    this.disabled=false;
                } else {
                    if(datos[0].existe=='no'){
                        this.existe='no';
                        this.filled=false;
                        this.disabled=false;
                    } else {
                        this.color_snack='error';
                        this.mensaje='Inconsistencia en los datos, informar a soporte';
                        this.snack=true
                    }
                }
            } catch (error) {
                console.log(error);
                this.color_snack='error';
                this.mensaje='Algo salio mal, informar a soporte';
                this.snack=true
            }
        }
        this.loading=false;
    },
    codePermiso(bolean){
        if(bolean){ return 1 } else { return 0 }
    },
    boleanPermiso(code){
        if(code==1){ return true } else { return false }
    },
    onlyDecimal ($event) {
        //console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
            $event.preventDefault();
        }
    },
    async dataUser(){
        console.log(this.existe)
        if(this.existe=="si"){ await this.updateUser() }
        if(this.existe=="no"){ await this.saveUser() }
    },
    async saveUser(){
        this.loading=true;
        try {
            if(this.usuario!='' && this.usuario!=null){
                if(this.estado!=''){
                    //obtener valor foto
                    const img = document.getElementById( 'img' );
                    this.foto = img.src;

                    const headers = {
                        'Content-Type' : 'application/json',
                        'Authorization' : 'Token ' + this.apikey
                    };
                    const params = {
                        contrato : this.contrato,
                        user: this.user,
                        rut: this.rut,
                        usuario: this.usuario,
                        clave: '123456',
                        tipo: this.tipo,
                        nombre: this.nombre,
                        telefono: this.telefono,
                        email: this.email,
                        comision: this.comision,
                        foto: this.foto,
                        permiso_01: this.codePermiso(this.permiso_1),
                        permiso_02: this.codePermiso(this.permiso_2),
                        permiso_03: this.codePermiso(this.permiso_3),
                        permiso_04: this.codePermiso(this.permiso_4),
                        permiso_05: this.codePermiso(this.permiso_5),
                        permiso_06: this.codePermiso(this.permiso_6),
                        permiso_07: this.codePermiso(this.permiso_7),
                        permiso_08: this.codePermiso(this.permiso_8),
                        permiso_09: this.codePermiso(this.permiso_9),
                        permiso_10: this.codePermiso(this.permiso_10),
                        permiso_11: this.codePermiso(this.permiso_11),
                        permiso_12: this.codePermiso(this.permiso_12),
                        estado: this.estado
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/user/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        this.color_snack='success';
                        this.mensaje='Usuario grabado con exito';
                        this.snack=true
                        this.btn_grabar=true;
                        await this.serachUsersList();
                    } else {
                        this.color_snack='error';
                        this.mensaje='No es posible grabar al usuario';
                        this.snack=true
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='Ingrese estado del usuario';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese usuario';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false
    },
    async updateUser(){
        this.loading=true;
        try {
            //obtener valor foto
            const img = document.getElementById( 'img' );
            this.foto = img.src;

            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user: this.user,
                rut: this.rut,
                usuario: this.usuario,
                tipo: this.tipo,
                nombre: this.nombre,
                telefono: this.telefono,
                email: this.email,
                comision: this.comision,
                foto: this.foto,
                permiso_01: this.codePermiso(this.permiso_1),
                permiso_02: this.codePermiso(this.permiso_2),
                permiso_03: this.codePermiso(this.permiso_3),
                permiso_04: this.codePermiso(this.permiso_4),
                permiso_05: this.codePermiso(this.permiso_5),
                permiso_06: this.codePermiso(this.permiso_6),
                permiso_07: this.codePermiso(this.permiso_7),
                permiso_08: this.codePermiso(this.permiso_8),
                permiso_09: this.codePermiso(this.permiso_9),
                permiso_10: this.codePermiso(this.permiso_10),
                permiso_11: this.codePermiso(this.permiso_11),
                permiso_12: this.codePermiso(this.permiso_12),
                estado: this.estado
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/user/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.color_snack='success';
                this.mensaje='Usuario actaulizado con exito';
                this.snack=true;
                this.btn_grabar=true;
                await this.serachUsersList();
            } else {
                this.color_snack='error';
                this.mensaje='No es posible grabar al usuario';
                this.snack=true
            }
        } catch (error) {
            console.log(error)
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false;
    },
    async resetPass(){
        this.loading=true;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user: this.user,
                clave: '123456',
                usuario: this.usuario,
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/reset/user/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                this.color_snack='success';
                this.mensaje='Clave reseteada con exito';
                this.snack=true
            } else {
                this.color_snack='error';
                this.mensaje='No es posible resetear clave';
                this.snack=true
            }
        } catch (error) {
            console.log(error);
            this.color_snack='error';
            this.mensaje='Algo salio mal, informar a soporte';
            this.snack=true
        }
        this.loading=false;
    },
    cambiaTipo(t){
        if(this.existe=='no'){
            if(t=='Administrador'){
                this.permiso_1 = true;
                this.permiso_2 = true;
                this.permiso_3 = true;
                this.permiso_4 = true;
                this.permiso_5 = true;
                this.permiso_6 = true;
                this.permiso_7 = true;
                this.permiso_8 = true;
                this.permiso_9 = true;
                this.permiso_10 = true;
                this.permiso_11 = true;
                this.permiso_12 = true;
            } else {
                this.permiso_1 = false;
                this.permiso_2 = false;
                this.permiso_3 = false;
                this.permiso_4 = false;
                this.permiso_5 = false;
                this.permiso_6 = false;
                this.permiso_7 = false;
                this.permiso_8 = false;
                this.permiso_9 = false;
                this.permiso_10 = false;
                this.permiso_11 = false;
                this.permiso_12 = false;
            }
        }
    }





  }
}
</script>
